module.exports = __webpack_public_path__ + "img/services-three-4.d2413706.jpg";